import { createTheme } from '@mui/material/styles';
export default function createCustomTheme(options) {
    return createTheme(options);
}
//# sourceMappingURL=createCustomTheme.js.map